export const buildConnectivityInfo = (segments = [], fromTime, toTime) => {
  if (
    !Number.isFinite(fromTime) ||
    !Number.isFinite(toTime) ||
    toTime <= fromTime
  ) {
    return [];
  }

  const validSegments = segments
    .filter(
      (segment) =>
        segment &&
        Number.isFinite(segment.startedAt) &&
        Number.isFinite(segment.endedAt) &&
        segment.endedAt > segment.startedAt &&
        segment.startedAt < toTime &&
        segment.endedAt > fromTime,
    )
    .map((segment) => ({
      ...segment,

      startedAt: Math.max(segment.startedAt, fromTime),

      endedAt: Math.min(segment.endedAt, toTime),
    }))
    .sort((a, b) => a.startedAt - b.startedAt);

  if (validSegments.length === 0) {
    return [];
  }

  const result = [];

  let currentTime = fromTime;

  validSegments.forEach((segment) => {
    const start = segment.startedAt;
    const end = segment.endedAt;

    if (start > currentTime) {
      result.push({
        name: "Online",
        value: [currentTime, start],
      });
    }

    const status = String(segment.status ?? "")
      .trim()
      .toLowerCase();

    result.push({
      name: status === "offline" ? "Offline" : "Online",
      value: [start, end],
    });

    currentTime = Math.max(currentTime, end);
  });

  if (currentTime < toTime) {
    result.push({
      name: "Online",

      value: [currentTime, toTime],
    });
  }

  return result;
};

export const calculateTotalOfflineDuration = (
  segments = [],
  fromTime,
  toTime,
) => {
  if (
    !Number.isFinite(fromTime) ||
    !Number.isFinite(toTime) ||
    toTime <= fromTime
  ) {
    return 0;
  }

  const offlineSegments = segments
    .filter(
      (segment) =>
        segment &&
        String(segment.status ?? "")
          .trim()
          .toLowerCase() === "offline" &&
        Number.isFinite(segment.startedAt) &&
        Number.isFinite(segment.endedAt) &&
        segment.endedAt > segment.startedAt &&
        segment.startedAt < toTime &&
        segment.endedAt > fromTime,
    )
    .map((segment) => ({
      start: Math.max(segment.startedAt, fromTime),

      end: Math.min(segment.endedAt, toTime),
    }))
    .sort((a, b) => a.start - b.start);

  if (offlineSegments.length === 0) {
    return 0;
  }

  let total = 0;

  let currentStart = offlineSegments[0].start;

  let currentEnd = offlineSegments[0].end;

  for (let i = 1; i < offlineSegments.length; i += 1) {
    const segment = offlineSegments[i];

    if (segment.start <= currentEnd) {
      currentEnd = Math.max(currentEnd, segment.end);
    } else {
      total += currentEnd - currentStart;

      currentStart = segment.start;

      currentEnd = segment.end;
    }
  }

  total += currentEnd - currentStart;

  return total;
};
